import { LinkedFirestoreDocument } from "@/core/modules/firestore/objects/LinkedFirestoreDocument";
import { ParcelType } from "./ParcelType";

import { StringField } from "@/core/fields";

export class LinkedParcelType extends LinkedFirestoreDocument {
  public name: string | undefined = undefined;

  public constructor(firestoreData?: Record<string, unknown>) {
    super();
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);
  }

  public static createFromParcelType(parcelType: ParcelType): LinkedParcelType {
    const linkedParcelType: LinkedParcelType = new LinkedParcelType();
    linkedParcelType.id = parcelType.id;
    linkedParcelType.name = parcelType.name;

    return linkedParcelType;
  }

  public fromFirestore(data: Record<string, unknown>): LinkedParcelType {
    super.fromFirestore(data);

    this.name = StringField.fromFirestore(data.name);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);

    return firestoreData;
  }
}
